import MOCK_CSC_CENTERS from './mockCscCentersData';

const SEED_FLAG = 'cscCentersSeeded_v3';

const seedCscCentersIfNeeded = () => {
  if (localStorage.getItem(SEED_FLAG)) return;
  localStorage.removeItem('cscCentersSeeded_v2');
  localStorage.setItem('cscCenters', JSON.stringify(MOCK_CSC_CENTERS));
  localStorage.setItem(SEED_FLAG, 'true');
};

export default seedCscCentersIfNeeded;
